import api from '../../../../api/client'

export async function listTaskMasters(params) {
  const { data } = await api.get('/masters/task-masters/', { params })
  return data
}

export async function getTaskMasterDetail(id) {
  const { data } = await api.get(`/masters/task-masters/${id}`)
  return data
}

export async function createTaskMaster(payload) {
  const { data } = await api.post('/masters/task-masters/', payload)
  return data
}

export async function updateTaskMaster(id, payload) {
  const { data } = await api.put(`/masters/task-masters/${id}`, payload)
  return data
}

export async function archiveTaskMaster(id) {
  const { data } = await api.post(`/masters/task-masters/${id}/archive`)
  return data
}

export async function unarchiveTaskMaster(id) {
  const { data } = await api.post(`/masters/task-masters/${id}/unarchive`)
  return data
}

export async function deleteTaskMaster(id) {
  const { data } = await api.post(`/masters/task-masters/${id}/delete`)
  return data
}

export async function getTaskMasterDropdown() {
  const { data } = await api.get('/masters/task-masters/dropdown')
  return Array.isArray(data) ? data : []
}
